/*
 * @Author: Damon
 * @Date: 2021-01-25 17:57:36
 * @LastEditors: Damon
 * @LastEditTime: 2021-04-05 17:27:33
 * @Description: file content
 */
// eslint-disable-next-line import/prefer-default-export
export const lang = {
  form: {
    login: {
      username: 'username',
      password: 'password',
      rememberMe: 'remember Me',
      login: 'log in',
      logout: 'log out',
    },

  },

  common: {
    submit: 'submit',
  },
  languageswitching: 'Language switching',
  exceptionpage: {
    index: 'Exception page',
    fourzeroone: '401 page',
    fourzerofour: '404 page',
  },
  dashboard: 'Dashboard',
  system: {
    index: 'system manage',
    user: 'user manage',
    role: 'role manage',
  },
  validate: {
    login: {
      accountrequired: 'account required',
      passwordrequired: 'password required',
      accountlengthgreaterthanfour: 'account number cannot be less than 4 digits',
      passwordlengthgreaterthansix: 'password cannot be less than 6 digits',
    },
    user: {
      accountrequired: 'account required',
      passwordrequired: 'password required',
      accountlengthgreaterthanfour: 'account number cannot be less than 4 digits',
      passwordlengthgreaterthansix: 'password cannot be less than 6 digits',
    },
  },
  table: {
    table: 'table',
    dynamictable: 'dynamic table',
    dragtable: 'drag table',
    inlineedittable: 'inline edit table',
    complextable: 'complex table',
  },
  component: {
    components: 'components',
    backtotop: 'back to top',
  },
  advisor: {
    manage: 'advisor manage',
    list: 'advisor list',
    edit: 'advisor edit',
    import: 'advisor import',
  },
  manager: {
    manage: 'manage',
    list: 'manager list',
    add: 'manager add',
    edit: 'manager edit',
    import: 'manager import',
  },
  branch: {
    manage: 'manage',
    list: 'branch list',
    edit: 'branch edit',
  },
  order: {
    manage: 'order manage',
    list: 'order list',
    detail: 'order detail',
    import: 'order import',
    sourcelist: 'order sourcelist',
    sourceadd: 'order source add',
  },
  excel: {
    manage: 'manage',
    upload: 'upload excel',
  },
  home: {
    page: '< home page',
  },
};



// WEBPACK FOOTER //
// ./src/assets/i18n/lang/en.js